import { Alinta, FlexGrid, AppMenu, AppFooter, Box, spacing } from '@alinta-digital/asg';
import { ApolloProvider } from '@apollo/client';

import React, { useState } from 'react';
import Payment from './Components/Payment/Payment';
import { PaymentFormProps } from '@alinta-digital/payment-form/PaymentForm';
import { BamboraPaymentDetails } from '@alinta-digital/payment-form/view';
import { getBffUrl, Environment } from './config';
import { createApolloClient } from './api/client';
import styled from 'styled-components';
import { analyticsHelperWebPayment } from '@alinta-digital/payment-form/utils/analytics';

const PageContent = styled.main`
  display: flex;
  flex: 1 0 auto;
  padding: ${spacing(16).medium};
`;

/** Bootstraps push method on data-layer for Google Tag Manager. This must be run instantly, therefore a useEffect cannot be used here. */
function useLoadGTM() {
  const [hasInit, setHasInit] = useState(false);

  if (!hasInit) {
    const buildEnv = process.env.REACT_APP_BUILD_ENV;
    if (buildEnv === 'development') {
      window['dataLayer'] = { push: console.log.bind(console) };
    } else if (buildEnv === 'uat' || buildEnv === 'prod' || buildEnv === 'test' || buildEnv === 'train') {
      (function (w, d, s, l, i) {
        // @ts-expect-error expected
        w[l] = w[l] || [];
        // @ts-expect-error expected
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        // eslint-disable-next-line no-var
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        // @ts-expect-error expected
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        // @ts-expect-error expected
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID);
    }
    setHasInit(true);
  }
}

const onCancel = /* istanbul ignore next */ () =>
  (window.location.href = process.env.REACT_APP_BASE_URL! + '/residential/billing-and-pricing/pay-your-bill/');

const processStartDateTime = Date.now();
/* istanbul ignore next */
const paymentProps: PaymentFormProps = {
  paymentDetails: {
    onCancel,
    onSubmit: () => undefined,
    guid: process.env.REACT_APP_WEB_CP_GUID!,
    baseURL: process.env.REACT_APP_BASE_URL!,
    environment: process.env.REACT_APP_BUILD_ENV === 'prod' ? Environment.Production : Environment.UAT,
    processStartDateTime,
    ga: analyticsHelperWebPayment
  },
  paymentSummary: {
    onCancel,
    onEdit: () => undefined,
    onSubmit: (bamboraPaymentDetails: BamboraPaymentDetails, proceedToNextStep: () => void) => undefined,
    processStartDateTime,
    ga: analyticsHelperWebPayment
  },
  paymentConfirmation: {
    onSubmit: () => (window.location.href = process.env.REACT_APP_BASE_URL!),
    myAccountBaseUrl: process.env.REACT_APP_MYACCOUNT_BASE_URL!,
    processStartDateTime,
    ga: analyticsHelperWebPayment,
    paymentType: 'card'
  },
  ga: analyticsHelperWebPayment
};

const App: React.FC = () => {
  useLoadGTM();

  const urlParams = new URLSearchParams(window.location.search);
  const isMobile = urlParams?.has('mobile');

  const apolloClient = createApolloClient(getBffUrl());

  return (
    <ApolloProvider client={apolloClient}>
      <Alinta>
        <FlexGrid direction="column" wrap="nowrap" height="100vh" alignItems="stretch" margin="none">
          {!isMobile && (
            <AppMenu
              phone="13 37 02"
              logoSrc="https://www.alintaenergy.com.au/-/media/alinta-website/data/media/img/alinta_default_logo_brand_refresh.png"
            />
          )}
          <PageContent>
            <Box maxWidth="1040px" width="100%" margin={{ horizontal: 'auto' }}>
              <Box margin={{ horizontal: 'small', top: 'xsmall', bottom: 'large' }}>
                <Payment {...paymentProps} />
              </Box>
            </Box>
          </PageContent>
          {!isMobile && <AppFooter phone="13 37 02" />}
        </FlexGrid>
      </Alinta>
    </ApolloProvider>
  );
};

export default App;
